import { render } from "./TutorsAdmin.vue?vue&type=template&id=25e5bc2e&scoped=true"
import script from "./TutorsAdmin.vue?vue&type=script&lang=js"
export * from "./TutorsAdmin.vue?vue&type=script&lang=js"

import "./TutorsAdmin.vue?vue&type=style&index=0&id=25e5bc2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e5bc2e"]])

export default __exports__